import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import { palette } from '@material-ui/system';

const useStyles = makeStyles((theme) => ({
  root: {
    top: 0,
    left: ({ position }) => {
      return position === 'left' ? 0 : undefined;
    },
    right: ({ position }) => {
      return position === 'right' ? 0 : undefined;
    },
    width: 4,
    height: '100%',
    position: 'absolute',
    backgroundColor: 'currentColor',
    borderRadius: ({ position }) => {
      if (position === 'left') {
        return theme.spacing(0, 0.5, 0.5, 0);
      }
      if (position === 'right') {
        return theme.spacing(0.5, 0, 0, 0.5);
      }
    },
    color: ({ color }) => palette({ theme, color }).color || 'inherit',
    transition: theme.transitions.create(['background-color', 'color'], {
      duration: theme.transitions.duration.shortest,
    }),
  },
}));

const Accent = (props) => {
  const { className, color, position = 'left' } = props;
  const classes = useStyles({ color, position });
  const rootClasses = cx(classes.root, className);

  return <div className={rootClasses} />;
};

export default Accent;
